import styled from 'styled-components';

interface StringCounterProps {
  currentCount: number;
  limitCount: number;
  style?: any;
}

function StringCounter({ currentCount, limitCount, style }: StringCounterProps) {
  return (
    <SWrapper style={style}>
      <span className="currentLength">{currentCount}</span>
      <span className="divider">/</span>
      {limitCount}
    </SWrapper>
  );
}

export default StringCounter;

const SWrapper = styled.div`
  color: ${(props) => props.theme.palette.neutral[30]};
  font-size: 12px;
  height: 16px;
  text-align: right;

  .divider {
    font-family: SF CompactDisplay-Regular;
  }
`;
